/* KFORU ENCORE — deals slideshow */
(function () {
  function initEncoreDeals(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var design = root.hasAttribute('data-design');
    var track = root.querySelector('[data-track]');

    // Page cache guard: drop deals that ended since the page was rendered.
    var nowS = Date.now() / 1000;
    if (!design) {
      Array.prototype.forEach.call(root.querySelectorAll('.encore-deals__slide'), function (s) {
        var end = +s.getAttribute('data-end');
        if (end && nowS >= end) s.parentNode.removeChild(s);
      });
    }
    var slides = Array.prototype.slice.call(root.querySelectorAll('.encore-deals__slide'));
    if (!slides.length) { root.hidden = true; return; }

    // Countdown on live deals.
    function tick() {
      var t = Date.now() / 1000;
      slides.forEach(function (s) {
        var el = s.querySelector('[data-countdown]');
        if (!el) return;
        var left = Math.max(0, +s.getAttribute('data-end') - t);
        var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60);
        el.textContent = '· ends in ' + (d > 0 ? d + 'd ' + h + 'h' : h > 0 ? h + 'h ' + m + 'm' : m + 'm');
      });
    }
    tick();
    setInterval(tick, 30000);

    var dotsWrap = root.querySelector('[data-dots]');
    var nav = root.querySelector('.encore-deals__nav');
    if (slides.length < 2) { if (nav) nav.hidden = true; return; }

    var dots = slides.map(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'encore-deals__dot-btn';
      b.setAttribute('aria-label', 'Go to deal ' + (i + 1));
      b.addEventListener('click', function () { go(i); stop(true); });
      dotsWrap.appendChild(b);
      return b;
    });

    var index = 0;
    function current() { return Math.round(track.scrollLeft / track.clientWidth); }
    function mark(i) {
      index = i;
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); s.inert = k !== i; });
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
    }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { var i = current(); if (i !== index) mark(i); });
    }, { passive: true });
    root.querySelector('[data-prev]').addEventListener('click', function () { go(index - 1); stop(true); });
    root.querySelector('[data-next]').addEventListener('click', function () { go(index + 1); stop(true); });
    mark(0);

    // Autoplay: pauses on hover, focus or touch; stays stopped once the shopper takes over.
    var secs = +root.getAttribute('data-autoplay') || 0;
    var pauseBtn = root.querySelector('[data-pause]');
    var timer = null, held = false, stopped = reduce || secs === 0 || design;
    function run() { clearInterval(timer); if (!stopped && !held) timer = setInterval(function () { go(index + 1); }, secs * 1000); }
    function stop(byUser) {
      stopped = true; clearInterval(timer);
      if (pauseBtn) { pauseBtn.setAttribute('aria-pressed', 'true'); pauseBtn.setAttribute('aria-label', 'Play slideshow'); }
    }
    if (pauseBtn) {
      if (stopped) stop();
      pauseBtn.addEventListener('click', function () {
        if (stopped) { stopped = false; pauseBtn.setAttribute('aria-pressed', 'false'); pauseBtn.setAttribute('aria-label', 'Pause slideshow'); run(); }
        else stop(true);
      });
    }
    root.addEventListener('mouseenter', function () { held = true; clearInterval(timer); });
    root.addEventListener('mouseleave', function () { held = false; run(); });
    root.addEventListener('focusin', function () { held = true; clearInterval(timer); });
    root.addEventListener('focusout', function () { held = false; run(); });
    track.addEventListener('pointerdown', function () { stop(true); }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) clearInterval(timer); else run(); });
    run();
  }
  function boot() { document.querySelectorAll('.encore-deals[data-deals]').forEach(initEncoreDeals); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();